export const extractAddressFromClientShippingAddress = (src) => {
    return {
        postalCode: src.postalCode,
        address: src.address,
    };
};
export const jpPostalCodeRegex = /^\d{7}$/;
export const validatePostalCode = (postalCode) => {
    return jpPostalCodeRegex.test(postalCode);
};
export const normalizePostalCode = (postalCode) => {
    const withoutHyphen = postalCode.replace('-', '').replace('ー', '');
    return withoutHyphen.replace(/[０-９]/g, (str) => {
        const charCode = str.charCodeAt(0);
        if (charCode >= 65281 && charCode <= 65374) {
            return String.fromCharCode(charCode - 65248);
        }
        else {
            return str;
        }
    });
};
export const newClientShippingAddress = (input) => {
    const postalCode = normalizePostalCode(input.postalCode);
    if (!validatePostalCode(postalCode)) {
        throw new Error('invalid postal code');
    }
    const now = new Date();
    return {
        ...input,
        postalCode,
        createdAt: now,
        updatedAt: now,
    };
};
//# sourceMappingURL=clientShippingAddress.js.map